import { Icon, Tooltip, TooltipProps } from 'components/common'

export type InfoProps = TooltipProps

export const Info = ({ children, ...props }: InfoProps): JSX.Element => (
  <>
    <div className={'flex items-center'}>
      <div>{children}</div>

      <Tooltip className={'ml-3'} {...props}>
        <Icon.QuestionCircleTwoTone />
      </Tooltip>
    </div>
  </>
)
